import "../../App.css";
import Sidebar from "../../components/Sidebar";
import "../../styles/login.css";
import { withRouter } from "react-router-dom";
import React, { useState, useEffect } from "react";
import UserTab from "../UserTab";
import Table from "../Table";
import Parametros from "../Parametros";
import CurrentUser from "../CurrentUser";
import EliminarElemento from "../EliminarElemento";

function TribunalRol(props) {
  const { history } = props;
  const [TribunalRolStateUpdate, setTribunalRolStateUpdate] = useState([]);
  const [TribunalRolState, setTribunalRolState] = useState([]);
  // eslint-disable-next-line
  const [usuario, setUsuario] = useState(CurrentUser.user);
  const [update, setUpdate] = useState(false);
  // eslint-disable-next-line
  const [formularioUpdate, setformularioUpdate] = useState({});
  const [paginacionState, setPaginacionState] = useState({
    limit: 5,
    skip: 1,
  });
  // eslint-disable-next-line
  useEffect(async () => {
    let response = await fetch(
      Parametros.urlApi + "court_roles?skip=0&limit=100&is_mantenedor=true",
      {
        headers: {
          Authorization: "Bearer " + usuario.key,
          Accept: "application/json",
          "Content-Type": "application/json",
          Origin: "https://d1tl5p9wrfnj29.cloudfront.net/",
        },
      }
    );
    if (response.status === 200 || response.status === 201) {
      let responseJson = await response.json();

      let responseJsonUpdate = JSON.stringify(responseJson);
      let responseJsonstate = JSON.stringify(responseJson);
      setTribunalRolState(JSON.parse(responseJsonUpdate));
      setTribunalRolStateUpdate(JSON.parse(responseJsonstate));
    } else if (response.status === Parametros.loginTokenExcept) {
      alert(Parametros.loginTokenExceptMessage);
      history.push({
        pathname: "/",
      });
    }
  }, [update, history, usuario]);
  const [formularioState, setFormularioState] = useState({
    name: "",
  });
  const [editable, setEditable] = useState({
    id: "",
  });
  let handleStageForm = (event) => {
    const value = event.target
      ? event.target.value
      : event.currentTarget.innerText;

    setFormularioState({
      ...formularioState,
      [event.target.name]: value,
    });
  };
  let crearTribunalRol = async (event) => {
    event.preventDefault();
    if (usuario.permisos.indexOf("Crear") > -1) {
      if (window.confirm("¿Esta seguro que deseas agregar este elemento?")) {
        let response = await fetch(Parametros.post + "court_roles", {
          method: "POST",
          body: JSON.stringify(formularioState),
          headers: {
            Authorization: "Bearer " + usuario.key,
            Accept: "application/json",
            "Content-Type": "application/json",
            Origin: "https://d1tl5p9wrfnj29.cloudfront.net/",
          },
        });

        let responseJson = await response.json();

        if (response.status === 200) {
          let newArray = TribunalRolState;
          setTribunalRolState(JSON.parse(JSON.stringify(newArray)));
          setTribunalRolStateUpdate(JSON.parse(JSON.stringify(newArray)));
          setUpdate(!update);
          alert("Se agregó correctamente");
          document.getElementById("formularioBusqueda").reset();
        } else if (response.status === Parametros.loginTokenExcept) {
          alert(Parametros.loginTokenExceptMessage);
          history.push({
            pathname: "/",
          });
        } else {
          alert(responseJson.detail);
        }
      } else {
        // Do nothing!
        setEditable({});
        // setpersonaEmpresaState(JSON.parse(JSON.stringify(personaEmpresaStateUpdate)))
      }
    } else {
      alert(usuario.crear);
    }
  };

  let TribunalRolHandleChange = (
    index,
    e,
    setState,
    listaState,
    autocomplete
  ) => {
    let newList = TribunalRolState;

    let value = e.currentTarget.value
      ? e.currentTarget.value
      : e.currentTarget.innerText;

    newList[index][e.target.getAttribute("name")] = value;
    setTribunalRolState(JSON.parse(JSON.stringify(newList)));
  };
  let confirmarEdicion = async (item) => {
    // setetapaStateUpdate(nuevoObjeto)

    if (usuario.permisos.indexOf("Editar") > -1) {
      if (window.confirm("¿Esta seguro que deseas editar este elemento?")) {
        let response = await fetch(
          Parametros.urlApi +
            "court_roles/" +
            parseInt(item.court_role_id) +
            "?name=" +
            item.name,
          {
            method: "PUT",
            headers: {
              Authorization: "Bearer " + usuario.key,
              Accept: "application/json",
              "Content-Type": "application/json",
              Origin: "https://d1tl5p9wrfnj29.cloudfront.net/",
            },
          }
        );

        let responseJson = await response.json();

        if (response.status === 200) {
          alert("ok");
          setUpdate(!update);
          setEditable({});
        } else if (response.status === Parametros.loginTokenExcept) {
          alert(Parametros.loginTokenExceptMessage);
          history.push({
            pathname: "/",
          });
        } else {
          alert(responseJson.detail);
          setTribunalRolState(
            JSON.parse(JSON.stringify(TribunalRolStateUpdate))
          );
          setEditable({});
        }
      } else {
        // Do nothing!
        setEditable({});
        setTribunalRolState(JSON.parse(JSON.stringify(TribunalRolStateUpdate)));
      }
    } else {
      alert(usuario.editar);
    }
  };

  let editar = (id) => {
    setTribunalRolState(JSON.parse(JSON.stringify(TribunalRolStateUpdate)));
    setEditable(id);
  };
  let cancelarEdicion = async (item) => {
    setEditable({});
    setTribunalRolState(JSON.parse(JSON.stringify(TribunalRolStateUpdate)));
  };

  return (
    <div className="App">
      <Sidebar tipo="2"></Sidebar>
      <br />
      <div className="container">
        <UserTab nombre={"Libro/Tipo"}></UserTab>
        <form id="formularioBusqueda" onSubmit={crearTribunalRol}>
          <div className="col-md-4">
            <h5>Nombre</h5>
            <input
              onChange={handleStageForm}
              name="name"
              value={formularioState.name}
              required
              className="form-control"
            ></input>
          </div>

          <div className="col-md-4">
            <br />
            <button
              type="submit"
              value="Submit"
              style={{ margin: "14px 0px" }}
              id="btnBuscar"
              className="form-control button brEdit btn-primary"
            >
              Agregar nuevo
            </button>
          </div>
        </form>

        <div
          className="col-md-12 table-responsive"
          style={{ height: 300, width: "100%" }}
        >
          <Table
            type={1}
            paginationBelow={true}
            paginas={Math.max(
              1,
              Math.ceil(TribunalRolState.length / paginacionState.limit)
            )}
            paginadorState={paginacionState}
            setPaginadoor={setPaginacionState}
            elementos={["Rol de tribunal"]}
          ></Table>

          <table className="table table-bordered" id="myTable">
            <Table type={2} elementos={["Rol de tribunal"]}></Table>
            {usuario.permisos.indexOf("Ver") > -1 ? (
              <tbody className="ajusteTabladata">
                {TribunalRolState.slice(
                  (paginacionState.skip - 1) * paginacionState.limit,
                  (paginacionState.skip - 1) * paginacionState.limit +
                    paginacionState.limit
                ).map((item, displayIndex) => {
                  const index =
                    (paginacionState.skip - 1) * paginacionState.limit +
                    displayIndex;
                  return (
                    <tr key={item.court_role_id}>
                      {editable === item.court_role_id ? (
                        <>
                          <td>{item.court_role_id}</td>
                          <td>
                            <input
                              value={item.name}
                              name="name"
                              onChange={(event) => {
                                TribunalRolHandleChange(index, event);
                              }}
                              className="form-control"
                            ></input>
                          </td>
                          <td>
                            <abbr title="Confirmar Edición">
                              <span
                                style={{ cursor: "pointer" }}
                                onClick={() => {
                                  confirmarEdicion(item);
                                }}
                                className="glyphicon glyphicon glyphicon-ok"
                              >
                                {" "}
                              </span>
                            </abbr>
                            <abbr title="Cancelar Edición">
                              <span
                                style={{ cursor: "pointer" }}
                                onClick={() => {
                                  cancelarEdicion(item);
                                }}
                                className="glyphicon glyphicon-share-alt"
                              ></span>
                            </abbr>
                          </td>
                        </>
                      ) : (
                        <>
                          <td>{item.court_role_id}</td>
                          <td>{item.name} </td>
                          <td>
                            <abbr title="Editar Elemento ">
                              <span
                                style={{ cursor: "pointer" }}
                                onClick={() => {
                                  editar(item.court_role_id);
                                }}
                                className="glyphicon glyphicon-pencil"
                              >
                                {" "}
                              </span>
                            </abbr>
                            <EliminarElemento
                              endpoint={`court_roles/${item.court_role_id}`}
                              onSuccess={() => {
                                setUpdate(!update);
                              }}
                            />
                          </td>
                        </>
                      )}
                    </tr>
                  );
                })}
              </tbody>
            ) : (
              <tbody>
                <td>{usuario.ver}</td>
              </tbody>
            )}
          </table>
          <Table
            type={3}
            paginas={Math.max(
              1,
              Math.ceil(TribunalRolState.length / paginacionState.limit)
            )}
            paginadorState={paginacionState}
            setPaginadoor={setPaginacionState}
          />
          {!usuario.permisos.indexOf("Ver") < -1 && usuario.ver}
        </div>
      </div>
    </div>
  );
}

export default withRouter(TribunalRol);
